import { useEffect, useState } from "react";
import ProviderDetailsComponent from "../../components/providerComponents/providerDetails/ProviderDetailsComponent";
import { useProviderContext } from "../../components/providerComponents/context/providerContext";
import AuthorisedRepresentativeManagementComponent from "../../components/authorisedRepresentativeManagement/AuthorisedRepresentativeManagementComponent";
import { RoleId } from "../../shared/enums/Role";
import { useApiClient } from "../../shared/customHooks";
import { useGlobalContext } from "../../shared/GlobalContext";
import { UserLinksDiscriminator } from "../../shared/enums/LinkDiscriminator";

export default function ProviderView() {
  const [loaded, setLoaded] = useState(false);

  const { setHeaderText, id, providerBase, rehydrate } = useProviderContext();
  const { fetchData } = useApiClient("UserManagement", { identity: true });
  const {
    accountInfo: { isManager },
  } = useGlobalContext();

  const [users, setUsers] = useState<any[]>([]);

  useEffect(() => {
    setHeaderText({
      value: "KIS Provider Details",
      icon: "view-app-icon mr-3 mt-0",
    });
    rehydrate().then(() => {
      setLoaded(true);
      fetchData(`getInvitedUsers/${id}`, { discriminator: 1 }).then((res: any) => {
        setUsers(res.data);
      });
    });
  }, []);
  const inviteText = "Select this button to send an invitation to a KIS Provider user to create a KIS portal account";

  return (
    <div className="w-full">
      {loaded && (
        <div className="flex flex-column align-items-start w-full height-calc">
          <ProviderDetailsComponent disabled={true} data={providerBase.providerDetails} />
          <AuthorisedRepresentativeManagementComponent
            inviteText={inviteText}
            id={id}
            label="Invite a user to join the KIS Provider"
            advisory="Enter the email address of the KIS Provider user that you wish to invite"
            otherValues={{
              providerName: providerBase.providerDetails.providerName,
              roleType: RoleId.Provider,
              userLinkDiscriminator: UserLinksDiscriminator.provider,
              authorisationLevel: 0,
            }}
            showInvite={isManager}
            data={users}
            tooltipText="Invite User to Provider"
          />
        </div>
      )}
    </div>
  );
}
